
import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import { Field } from 'formik';
import NameField from 'components/forms/new/formikFormFields/NameField';

const CallInclusionAmountField = ({ darkMode, errors,touched, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl sx={{ margin: '0 !important' }} isInvalid={!!errors.outboundRate && touched}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)} color={darkMode ? 'white' : 'black'}>
                        Included Minutes <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} fontSize="sm" color={darkMode ? 'gray.300' : 'gray.600'} maxWidth={250}>
                        Enter the number of included minutes.
                    </Text>
                </Box>
                <Box flex="1" minWidth="250px">
                           <Box sx={{ display: 'flex', width: '100%', alignItems: 'flex-start', paddingTop: '8px', marginRight: '6px'  }}>
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NameField}
                            id="inclusionAmount"
                            name="inclusionAmount"
                            validate={value => !value && 'Inclusion Amount is required'}
                            error={errors.inclusionAmount}
                            {...props}
                        />
                        

                    </VStack>
                    {isHovered && (
                    <FieldToolTip
                        label="Enter the number of included minutes."
                        ariaLabel="calling-rate-name-tip"
                        left="25px"
                        top="25px"
                    />
                )}
                    </Box>
                </Box>
                
            </Stack>
        </FormControl>
    );
};

export default CallInclusionAmountField;
